import { Box, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import Heading, { HeadingSize, headingCID } from '../Heading';

import ContainerFloat from './ContainerFloat';

export interface ContainerHeaderProps {
  float?: React.ReactNode;
  floatResponsive?: boolean;
  title: string;
}

const HEADER_GAP = 4;

/**
 * Holds a header and menu items that float to the top right of the container
 */
const ContainerHeader: FC<PropsWithChildren<ContainerHeaderProps>> = ({ children, float, floatResponsive, title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        [`& .${headingCID}`]: {
          marginBottom: 0,
        },
        alignItems: { xs: floatResponsive ? 'start' : 'center', md: 'center' },
        display: 'flex',
        marginBottom: '1rem',
        marginTop: '1rem',
        flexDirection: { xs: floatResponsive ? 'column' : 'row', md: 'row' },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          width: '100%',
          gap: theme.spacing(HEADER_GAP),
          paddingBottom: '5px',
          paddingTop: '5px',
        }}
      >
        <Heading size={HeadingSize.LG}>{title}</Heading>
        {children}
      </Box>
      {float && <ContainerFloat floatResponsive={floatResponsive}>{float}</ContainerFloat>}
    </Box>
  );
};

export default ContainerHeader;
